import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Button } from '@material-ui/core';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';

import {errorMessage$, successMessage$} from '../../../utils/subjects';
import api from '../../../services/api';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function DialogDateOutType({handleClose, handleOpen, open, callback}) {
  const classes = useStyles();
  const [description, setDescription] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      const data = {
        Description: description
      };

      handleClose();
      await api.post(`scheduling/date-out-types`, data);
      
      successMessage$.next({open: true, message: 'Date out type created successfully'});
      if (callback) callback();

    } catch (err) {
      console.log(err);
      errorMessage$.next({open: true, message: 'Error on create date out type'});
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title"  style={{ minWidth: 200 }}>
      <DialogTitle id="form-dialog-title">+ Add date out type</DialogTitle>
      <form className={classes.root} onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            autoFocus
            id="description"
            label="Description"
            type="text"
            fullWidth
            value={description}
            onChange={e => setDescription(e.target.value)}
            style={{marginBottom: 8}}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="default">
            Cancel
          </Button>
          <Button color="primary" type="submit">
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}